import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { McpServer } from '../types';
import { fetchMcpRegistry } from '../lib/marketplace';

interface McpRegistryContextValue {
  servers: McpServer[];
  loading: boolean;
  error: string | null;
}

const McpRegistryContext = createContext<McpRegistryContextValue | null>(null);

export function McpRegistryProvider({ children }: { children: React.ReactNode }) {
  const [servers, setServers] = useState<McpServer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const data = await fetchMcpRegistry();
      setServers(data);
      setError(null);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <McpRegistryContext.Provider value={{ servers, loading, error }}>
      {children}
    </McpRegistryContext.Provider>
  );
}

export function useMcpRegistry() {
  const ctx = useContext(McpRegistryContext);
  if (!ctx) throw new Error('useMcpRegistry must be used within McpRegistryProvider');
  return ctx;
}
